const $Navigation4AMenuTrigger = $('.js-menu-trigger', '.component-navigation-4A');
const $Navigation4AMenuItemContentTrigger = $('.js-menu-item-content-trigger', '.component-navigation-4A');

const Navigation4A = document.getElementsByClassName('component-navigation-4A--state')[0];
const Navigation4ATop = document.getElementsByClassName('component-navigation-4A__top')[0];
const Navigation4ABottom = document.getElementsByClassName('component-navigation-4A__bottom')[0];

if (Navigation4A && Navigation4ATop && Navigation4ABottom) {
    let Navigation4AIsPastTop = false;
    let Navigation4AIsPastBottom = false;
    let Navigation4ABottomObserver;

    //1. Observer for Point A (Start Sticky)
    const topObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            Navigation4AIsPastTop = !entry.isIntersecting && entry.boundingClientRect.y < 0;
            Navigation4AUpdateNavState();
        });
    });
    topObserver.observe(Navigation4ATop);
    
    // 2. Function to build the bottom observer
    function Navigation4ACreateBottomObserver() {
        // Clear out the old observer if it exists
        if (Navigation4ABottomObserver) {
            Navigation4ABottomObserver.disconnect();
        }

        const Navigation4AHeight = Navigation4A.offsetHeight;

        Navigation4ABottomObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                Navigation4AIsPastBottom = !entry.isIntersecting && entry.boundingClientRect.y <= (Navigation4AHeight + 2);
                Navigation4AUpdateNavState();
            });
        }, {
            // Set the new margin based on the fresh height
            rootMargin: `-${Navigation4AHeight}px 0px 0px 0px` 
        });
        
        Navigation4ABottomObserver.observe(Navigation4ABottom);
    }

    // Initialize the bottom observer on page load
    Navigation4ACreateBottomObserver();

    // 3. ResizeObserver to catch display: none -> display: block changes
    const resizeObserver = new ResizeObserver(() => {
        // Force a manual check of the top trigger. This catches the layout shift 
        // if the trigger was already scrolled past while the nav was hidden.
        Navigation4AIsPastTop = Navigation4ATop.getBoundingClientRect().y < 0;
        
        Navigation4ACreateBottomObserver();
        Navigation4AUpdateNavState();
    });
    resizeObserver.observe(Navigation4A);

    // 4. Central Logic for the Nav State
    function Navigation4AUpdateNavState() {
         // Safeguard: If the nav is hidden on mobile, strip sticky classes and stop
        if (Navigation4A.offsetHeight === 0) {
            Navigation4A.classList.remove('is-sticky', 'is-hidden');
            return;
        }

        if (!Navigation4AIsPastTop) {
            // Zone 1: Above Point A (Normal flow)
            Navigation4A.classList.remove('is-sticky', 'is-hidden');
            
        } else if (Navigation4AIsPastTop && !Navigation4AIsPastBottom) {
            // Zone 2: Between Point A and Point B (Strictly Sticky)
            Navigation4A.classList.add('is-sticky');
            Navigation4A.classList.remove('is-hidden');
            
        } else if (Navigation4AIsPastBottom) {
            // Zone 3: Below Point B (Inactive/Hidden)
            Navigation4A.classList.remove('is-sticky');
            Navigation4A.classList.add('is-hidden');
        }
    }
}

$Navigation4AMenuTrigger.on('click', function() {
    var $navigation = $(this).parents('.component-navigation-4A');
    var $subnavigation = $('.component-navigation-4A__sub-navigation', $navigation);
    var height = $('.component-navigation-4A__sub-navigation-blocks', $navigation).outerHeight(true);
    
    if (!$navigation.is('.active')) {
        $navigation.addClass('active');
        $subnavigation.slideDown('slow');
    } else {
        $navigation.removeClass('active');
        $subnavigation.slideUp('slow');
    }
});

$Navigation4AMenuItemContentTrigger.on('click', function() {
    var $that = $(this);
    var $SubNavigation = $that.parents('.component-navigation-4A__sub-navigation');
    var $SubNavigationBlock = $that.parents('.component-navigation-4A__sub-navigation-block');
    var $SubNavigationTopLevelItemContent = $SubNavigationBlock.find('.component-navigation-4A__sub-navigation-top-level-item-content');// $that.next('.component-navigation-4A__sub-navigation-top-level-item-content');
    var $SubNavigationTopLevelItemContentInnerContainer = $('.component-navigation-4A__sub-navigation-top-level-item-content-inner-container', $SubNavigationTopLevelItemContent);
    var height = $SubNavigationTopLevelItemContentInnerContainer.outerHeight(true);
    
    if ($SubNavigationBlock.is('.active')) {
        $SubNavigationBlock.removeClass('active')
        $SubNavigationTopLevelItemContent.height(0);
    } else {
        $('.component-navigation-4A__sub-navigation-block', $SubNavigation).removeClass('active');
        $('.js-menu-item-content-trigger', $SubNavigation).removeClass('active');
        $('.component-navigation-4A__sub-navigation-top-level-item-content', $SubNavigation).height(0);
        
        $SubNavigationBlock.addClass('active');
        $SubNavigationTopLevelItemContent.height(height);
    }
});